module.exports = __webpack_public_path__ + "static/media/logo.66fe6b1d.svg";